import { render, staticRenderFns } from "./Homecategory.vue?vue&type=template&id=431797d4"
import script from "./Homecategory.vue?vue&type=script&lang=js"
export * from "./Homecategory.vue?vue&type=script&lang=js"
import style0 from "./Homecategory.vue?vue&type=style&index=0&id=431797d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports